import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Interface para tipado
 */
export interface TipoPrograma {
  id?: number;
  descripcion: string;
  estado?: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

@Injectable({
  providedIn: "root",
})
export class TipoProgramaService {
  private apiUrl = `${environment.apiUrl}/api/tipo-programa`;

  constructor(private http: HttpClient) {}

  // Listar todos
  getTipos(): Observable<TipoPrograma[]> {
    return this.http
      .get<TipoPrograma[]>(this.apiUrl, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getTiposActivos(): Observable<TipoPrograma[]> {
    return this.http
      .get<TipoPrograma[]>(`${this.apiUrl}/activos`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Obtener por ID
  getTipoById(id: number | string): Observable<TipoPrograma> {
    return this.http
      .get<TipoPrograma>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  
  getAllRelacion(): Observable<TipoPrograma[]> {
    return this.http
      .get<TipoPrograma[]>(`${this.apiUrl}/tipos`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Crear
  createTipo(payload: TipoPrograma): Observable<TipoPrograma> {
    return this.http
      .post<TipoPrograma>(this.apiUrl, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Actualizar
  updateTipo(id: number | string, payload: TipoPrograma): Observable<TipoPrograma> {
    return this.http
      .put<TipoPrograma>(`${this.apiUrl}/${id}`, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Eliminar
  deleteTipo(id: number | string): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Activar
  activar(id: number | string): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Inactivar
  inactivar(id: number | string): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }
}
